import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogContent: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: 0,
    padding: 0,
    borderTop: `2px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    borderBottom: `2px solid ${capitalDesignTokens.semanticColors.border.primary}`
  },

  container: {
    display: 'flex',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden'
  },

  formContainer: {
    paddingLeft: '24px',
    paddingRight: '16px',
    minHeight: 0,
    minWidth: '280px',
    overflow: 'auto',
    flex: 1
  }
});
